import { render, staticRenderFns } from "./AppointmentHistoricalWrapper.vue?vue&type=template&id=369282ea"
import script from "./AppointmentHistoricalWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentHistoricalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369282ea')) {
      api.createRecord('369282ea', component.options)
    } else {
      api.reload('369282ea', component.options)
    }
    module.hot.accept("./AppointmentHistoricalWrapper.vue?vue&type=template&id=369282ea", function () {
      api.rerender('369282ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/AppointmentHistoricalWrapper.vue"
export default component.exports